export default __webpack_public_path__ + "static/media/PRA_Wrong_Object-v2.28cbda93.wav";